const templates = {
    "shop.okraina.ru": {
        title: "Каталог продуктов в интернет-магазине «ОКРАИНА»",
        tags: [
            {
                name: "description",
                content: "Каталог продукции интернет-магазина «ОКРАИНА». Бесплатная доставка, выгодные цены, натуральные и качественные мясные изделия, произведенные в день доставки заказа! Скидки постоянным покупателям!",
            }
        ]
    },
    "dostavka.okraina.ru": {
        title: "Купить колбасу в Мурманске, доставка качественной колбасы от производителя на дом, сколько стоят хорошие натуральные колбасные изделия «Окраина»",
        tags: [
            {
                name: "description",
                content: "Большой выбор колбасы в интернет-магазине «Окраина». Бесплатная доставка, выгодные цены, натуральные и качественные мясные изделия, произведенные в день доставки заказа! Скидки постоянным покупателям!",
            }
        ]
    },
}

export default templates;